module.exports = __webpack_public_path__ + "static/media/dinner5.d7ab9604.png";